import { z } from 'zod';

export const shareBySheetKeys = z.enum(['activeKey']);
export const activeKeyQueryKeys = z.enum([
  'basic-information',
  'detailed-breakdown',
  'activities',
  'inspection-evaluation',
  'payment',
  'related-material',
  'fund-investments',
  'fund-business',
  'ownership-ratio',
  'income-and-expenditure',
  'fund-additional-attributes',
  'execution-progress',
]);

export const activityTabKeys = z.enum(['activities', 'activity-flow']);
export const activityTabQueryKeys = z.enum([
  'routeIndicatorIds',
  'activitiesTabKey',
]);
